import { FC } from 'react';
import Link from 'next/link';
import { useGetBaseInfoConfig } from '@/queries/baseInfo';
import { useGetUser } from '@/queries/user';
import { Button } from '@mofid-securities/uikit';
import { StickyFooter } from '@/layouts/StickyFooter';
import { ExternalSiteEntry } from '@/components/ExternalSiteEntry';
import { useRegState } from '@/modules/register/hooks/useRegState';
import { returnExternalSiteEntries } from '../utils';

interface IRegisterCompletedActionsProps {
  extraCtaFunctionality?: () => void;
}

export const RegisterCompletedActions: FC<IRegisterCompletedActionsProps> = ({
  extraCtaFunctionality,
}) => {
  const { regStateReturnUrl, backButtonText, isRegisterCompleteSourceUnknown } =
    useRegState();
  const { data: user } = useGetUser();
  const { returnConfigUrl } = useGetBaseInfoConfig();
  const externalSiteEntries = returnExternalSiteEntries(!!user?.isOrbisUser);

  return (
    <StickyFooter onClick={extraCtaFunctionality}>
      {isRegisterCompleteSourceUnknown ? (
        <div className="flex flex-col gap-y-3">
          {externalSiteEntries.map((item, index) => (
            <ExternalSiteEntry
              key={index}
              imageAlt={item?.imageAlt}
              imageSrc={item?.imageSrc}
              link={returnConfigUrl(item?.desktopConfig)}
              mobileLink={returnConfigUrl(item?.mobileConfig)}
              title={item.title}
            />
          ))}
        </div>
      ) : (
        <Link href={regStateReturnUrl || '/'}>
          <Button className="md:mt-14" variant="outline" isFullWidth>
            {backButtonText}
          </Button>
        </Link>
      )}
    </StickyFooter>
  );
};
